// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-simple-page',
    // #endregion
    // #region Properties
    props: {
        showLogo: {
            type: Boolean,
            required: false,
            default: true,
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        backLinkPath: {
            type: String,
            required: false,
            default: ''
        },
    },
    // #endregion
});
// #endregion
